import { memo } from 'react';

import { InceptIcon, InceptIconProps } from '../InceptIcon';

const IconAssetTrailerComponent: React.FC<InceptIconProps> = ({
  color = 'var(--chakra-colors-brand-primary-fg, currentColor)',
  brandColor = 'var(--chakra-colors-brand-primary-solid)',
  fillColor = 'var(--chakra-colors-brand-primary-contrast)',
  viewBox = '0 0 80 80',
  ...props
}: InceptIconProps) => (
  <InceptIcon viewBox={viewBox} {...props}>
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="0.75"
    >
      <path
        d="m28.788 58.527-.342 7.92-16.569-9.566.343-7.92zM15.024 34.756l16.568 9.566-2.804 14.205L12.22 48.96z"
        fill={fillColor}
        stroke="#000"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M26.663 52.974a.2.2 0 0 0 .198-.162l1.347-6.825a.2.2 0 0 0-.096-.213L17.435 39.61a.202.202 0 0 0-.297.135l-1.347 6.825a.2.2 0 0 0 .096.213l10.676 6.164a.2.2 0 0 0 .1.027Z"
        fill={brandColor}
        stroke="#000"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m53 49.426 2.463 1.422-.211-1.639c-.074-.578-.537-.774-1.083-.458z"
        fill={fillColor}
        stroke="#000"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M31.594 44.322 68.319 23.12l-15.57-8.989a2 2 0 0 0-2 0L15.024 34.756z"
        fill={fillColor}
        stroke="#000"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M53.983 51.503c0 1.188-.834 2.634-1.864 3.229-1.03.594-1.864.112-1.864-1.077 0-1.188.834-2.634 1.864-3.229 1.03-.594 1.864-.112 1.864 1.077Z"
        fill={brandColor}
        stroke="#000"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M54.12 49.123c-.33-.192-.741-.242-1.201-.133a3 3 0 0 0-.8.329c-1.56.9-2.823 3.09-2.823 4.89q.001.482.115.857c.133.444.375.77.696.961l-1.877-1.083-.03-.018c-.503-.298-.813-.927-.813-1.819 0-1.8 1.264-3.99 2.824-4.89.78-.451 1.488-.493 2-.196l1.909 1.102Z"
        fill={color}
        stroke="#000"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M54.12 49.123 52.21 48.02c-.287-.166-.636-.227-1.025-.167l1.908 1.102c.39-.06.738 0 1.025.167ZM48.2 54.926l.03.018 1.877 1.083c-.276-.164-.494-.428-.634-.781l-1.908-1.102c.14.353.358.618.635.782Z"
        fill={color}
        stroke="#000"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M48.9 49.346c-.9 1.065-1.513 2.507-1.513 3.761 0 .401.063.749.178 1.037l1.908 1.102a2 2 0 0 1-.062-.18 3 3 0 0 1-.115-.857c0-1.254.613-2.697 1.512-3.761L48.9 49.346Z"
        fill={fillColor}
        stroke={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M52.119 49.319q.418-.24.8-.33.09-.02.175-.033l-1.908-1.102a2.8 2.8 0 0 0-.976.363c-.473.273-.919.665-1.31 1.129l1.908 1.102a5.1 5.1 0 0 1 1.31-1.13Z"
        fill="#777D87"
        stroke="#000"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M54.942 50.949c0 1.8-1.264 3.99-2.823 4.89-1.56.9-2.823.17-2.823-1.63s1.264-3.99 2.823-4.89c1.56-.9 2.823-.17 2.823 1.63Z"
        fill={fillColor}
        stroke="#000"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M68.319 23.12 31.592 44.322l-2.804 14.204-.342 7.92 20.682-11.94.059-1.677c.024-.686.506-1.495 1.092-1.833l3.89-2.246c.546-.316 1.009-.12 1.083.458l.212 1.64 9.39-5.422 3.73-3.746c.277-.28.433-.656.433-1.05z"
        fill={fillColor}
        stroke="#000"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m60.863 31.561 3.628-2.094a.56.56 0 0 1 .838.483v5.4c0 .2-.107.384-.28.484l-4.186 2.417zM50.162 37.739l9.346-5.396v6.69l-8.787 5.073a.56.56 0 0 1-.838-.483v-5.4c0-.2.107-.384.28-.484ZM34.289 46.904l5.42-3.13a.458.458 0 0 1 .688.397v5.591c0 .189-.1.363-.264.457l-5.703 3.293a.5.5 0 0 1-.748-.432v-5.127c0-.433.232-.833.607-1.05Z"
        fill={brandColor}
        stroke="#000"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M63.43 40.746a.297.297 0 0 1 .297.298v3.25a.43.43 0 0 1-.212.367l-5.77 3.331a.42.42 0 0 1-.424 0 .42.42 0 0 1-.213-.368V44.77c0-.259.14-.5.364-.63l5.809-3.354a.3.3 0 0 1 .149-.04Z"
        fill={fillColor}
        stroke="#000"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M47.2 55.62V39.364c0-.229-.07-.4-.189-.47-.12-.069-.258-.018-.352.037l-3.674 2.12c-.35.203-.634.75-.634 1.22V58.42"
        stroke="#000"
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </InceptIcon>
);

export const IconAssetTrailer = memo(IconAssetTrailerComponent);
